import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "ri-bold" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "ri-italic" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "ri-underline" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "ri-list-unordered" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "ri-list-ordered" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor_content = _resolveComponent("editor-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.editor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            disabled: this.disabled,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editor.chain().focus().toggleBold().run())),
            class: _normalizeClass({ 'is-active': _ctx.editor.isActive('bold') })
          }, _hoisted_4, 10, _hoisted_2),
          _createElementVNode("button", {
            disabled: this.disabled,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editor.chain().focus().toggleItalic().run())),
            class: _normalizeClass({ 'is-active': _ctx.editor.isActive('italic') })
          }, _hoisted_7, 10, _hoisted_5),
          _createElementVNode("button", {
            disabled: this.disabled,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editor.chain().focus().toggleUnderline().run())),
            class: _normalizeClass({ 'is-active': _ctx.editor.isActive('underline') })
          }, _hoisted_10, 10, _hoisted_8),
          _createElementVNode("button", {
            disabled: this.disabled,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editor.chain().focus().toggleBulletList().run())),
            class: _normalizeClass({ 'is-active': _ctx.editor.isActive('bulletList') })
          }, _hoisted_13, 10, _hoisted_11),
          _createElementVNode("button", {
            disabled: this.disabled,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editor.chain().focus().toggleOrderedList().run())),
            class: _normalizeClass({ 'is-active' : _ctx.editor.isActive('orderedList') })
          }, _hoisted_16, 10, _hoisted_14)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_editor_content, {
      editor: _ctx.editor,
      modelValue: _ctx.modelValue,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelValue) = $event)),
      class: "form-control editorContent editor"
    }, null, 8, ["editor", "modelValue"])
  ], 64))
}